<template>
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H8C9.65685 0 11 1.34315 11 3V11C11 12.6569 9.65685 14 8 14H3C1.34315 14 0 12.6569 0 11V3Z"
      :fill="fill"
    />
  </svg>
</template>
<script setup lang="ts">
    interface Props{
        fill?:string;
    }

    withDefaults(defineProps<Props>(),{
        fill: '#FFE100'
    })
</script>

<script lang="ts">
export default {};
</script>
